import { DiplomaItem, IDiplomaItem } from './diploma-item';

export interface IDiploma {
  _id?: string;
  capacity?: string;
  coc?: IDiplomaItem;
  coe?: IDiplomaItem;
  title?: string;
}

export class Diploma implements IDiploma {
  _id?: string;
  capacity: string;
  coc: DiplomaItem;
  coe: DiplomaItem;
  title: string;

  constructor( diploma: IDiploma = {} ) {
    this._id = diploma._id;
    this.capacity = diploma.capacity;
    this.coc = new DiplomaItem(diploma.coc);
    this.coe = new DiplomaItem(diploma.coe);
    this.title = diploma.title;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/diploma.ts